<template>
  <VcLayout column>
    <VcLayout column class="mobile-custom-instructions-wrapper">
      <VcLayout v-if="isGenerating" class="ai-cover" align-start>
        <VcLayout align-center>
            <span class="ai-cover--icon ml-4">
              <StarAi />
            </span>
          <span class="ml-4">{{ $t('ai_content_generator.custom_instructions.generating_text') }}</span>
          <VcLink :label="$t('ai_content_generator.custom_instructions.cancel_btn')"
                  @click="$emit('cancelAiGeneration')"
                  class="ai-cover--link ml-4"
          />
        </VcLayout>
      </VcLayout>
      <VcLayout v-else class="mobile-custom-instructions-preview pa-4">
        <VcLayout justify-space-between column class="mobile-custom-instructions-preview-content">
          <div class="mobile-custom-instructions-preview-text pb-14" v-html="currentMessage"></div>
        </VcLayout>
      </VcLayout>
      <VcLayout v-if="generatedReply && generatedReply.trim()"
                class="mobile-custom-instructions-input-container"
                column
      >
        <div class="mobile-custom-instructions-generated">
          <VcAiButton
            pill
            small
            secondary
            use-ai-icon
            secondary-variant="gradient"
            :label="$t('ai_content_generator.custom_instructions.insert_reply_label')"
            @click="$emit('insertReply')"
            dataQa="insert-smart-reply-mobile"
            class="ai-btn"
          />
        </div>
      </VcLayout>
    </VcLayout>
  </VcLayout>
</template>

<script>
import VcAiButton from '@vcita/design-system/src/components/VcAiButton/VcAiButton.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MobileCustomInstructions',
  components: {
    VcAiButton,
    StarAi: () => import('@/modules/bizai/assets/starAi.svg'),
  },
  props: {
    currentMessage: {
      type: String,
      default: '',
    },
    generatedReply: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('CommonStore', ['isMobile']),
    ...mapGetters('AiGeneratorStore', ['isGenerating']),
  },
};
</script>

<style lang="scss" scoped>
@keyframes star-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.mobile-custom-instructions-wrapper {
  height: 100%;
}

.mobile-custom-instructions-preview {
  position: relative;
  background-color: var(--gray-lighten-4);
  border-bottom: 1px solid var(--gray-lighten-3);
  height: 100%;
  overflow: auto;

  .mobile-custom-instructions-preview-content {
    gap: 8px;
  }

  .mobile-custom-instructions-preview-text {
    font-size: var(--font-size-small);
  }
}

.mobile-custom-instructions-generated {
  position: absolute;
  left: var(--size-value4);
  top: -48px;
}

.mobile-custom-instructions-input-container {
  position: relative;
}

.ai-cover {
  height: 100%;
  gap: var(--size-value4);
  padding: var(--size-value4);
  background-color: var(--gray-lighten-4);

  &--icon {
    width: var(--size-value4);
    height: var(--size-value4);
    animation: star-rotate 2.5s linear infinite;
  }
  .ai-cover--link {
    padding-top: 0;
  }
}
</style>
